import * as Tooltip from '@radix-ui/react-tooltip';

import type { RebuyHigherFlagDto } from '../../lib/api/endpoints';
import { formatCurrency } from '../../lib/format/currency';

interface RebuyHigherBadgeProps {
  flag: RebuyHigherFlagDto;
  currency: string;
  className?: string;
}

function dateLabel(value: string): string {
  return value.slice(0, 10);
}

function moneyLabel(value: string, currency: string): string {
  const formatted = formatCurrency(value, currency);
  return currency === 'USD' ? formatted.replace('US$', '$') : formatted;
}

export function RebuyHigherBadge({ className = '', currency, flag }: RebuyHigherBadgeProps) {
  const tooltip = `Sold at ${moneyLabel(flag.sellPrice, currency)} on ${dateLabel(
    flag.sellDate,
  )}, rebought at ${moneyLabel(flag.buyPrice, currency)} on ${dateLabel(
    flag.buyDate,
  )} (+${flag.pctAbove.toFixed(1)}%)`;

  return (
    <Tooltip.Provider delayDuration={150}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            aria-label={tooltip}
            className={`inline-flex rounded border border-warn/60 bg-warn-subtle px-2 py-0.5 text-xs font-medium text-amber-100 ${className}`}
            title={tooltip}
            type="button"
          >
            Rebuy higher
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="z-50 max-w-xs rounded border border-border bg-surface-raised px-3 py-2 text-xs text-text shadow-lg"
            sideOffset={6}
          >
            {tooltip}
            <Tooltip.Arrow className="fill-surface-raised" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
